import React, { useMemo } from 'react'

import { List } from '@material-ui/core'
import { get, keyBy } from 'lodash'
import { isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { DOMAIN_TYPES } from 'common/track-event-constants'
import { FocusDropdownTitle } from 'components/AwesomeBar'
import { selectGroups } from 'store/prospects'

import ResultComponent from '../../use-search-configurations/search-colleges/ResultComponent'
import { useRandomYouMayAlsoLike } from './use-random-you-may-also-like'

/**
 * Display colleges you may also like
 * @param {object} props
 * @prop {bool} open
 * @returns YouMayAlsoLike component
 */
const YouMayAlsoLike = ({ open, groups, onCloseFocusDropdown }) => {
  const { following, count } = useMemo(() => {
    const list = [...get(groups, 'following', []), ...get(groups, 'applying', []), ...get(groups, 'applied', [])]
    const following = keyBy(list, 'CollegeScid')
    return {
      following,
      count: list.length,
    }
  }, [groups])
  const colleges = useRandomYouMayAlsoLike(open, following, count)

  return isEmpty(colleges) ? null : (
    <List id="main-nav-you-may-also-like">
      <FocusDropdownTitle>You May Also Like</FocusDropdownTitle>
      {!open
        ? null
        : map(colleges, ({ SchoolName, Name, Scid, City, State }, locationIndex) => {
            return (
              <ResultComponent
                key={locationIndex}
                scid={Scid}
                name={SchoolName || Name}
                city={City}
                state={State}
                additionalMetatdata={{
                  domainType: DOMAIN_TYPES.GLOBAL_SEARCH_YMAL,
                  locationIndex,
                }}
                listItemProps={{
                  button: true,
                  disableGutters: false,
                  style: {
                    padding: '8px 16px',
                  },
                  onClick: onCloseFocusDropdown,
                }}
              />
            )
          })}
    </List>
  )
}

YouMayAlsoLike.propTypes = {
  open: PropTypes.bool,
  groups: PropTypes.object,
  onCloseFocusDropdown: PropTypes.func,
}

export default connect(
  (store) => ({
    groups: selectGroups(store),
  }),
  {},
)(YouMayAlsoLike)
